export const PAGE_HEADER_HEIGHT = 72; // This matches the pt-[72px] being used

export const pageHeaderStyles = {
  paddingTop: `${PAGE_HEADER_HEIGHT}px`
};